import { useMemo } from 'react';

import { useGetCategoryListQuery } from '@/Module/Grade/Store/Query/CategoryListQuery';

export const useFindCategory = () => {
  const { data: Category = [] } = useGetCategoryListQuery();
  return useMemo(() => {
    return Category.filter(item => item.categoryTypeId === 2).slice(0, 12);
  }, [Category]);
};
